function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { cancelSubscriptionRenewal, closeConfirmation, getFullUserDetails, openConfirmation, openWriteToUs } from "@common/actions/index";
import { SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS, STATUS_CODE_SUCCESS, SUBSCRIPTION } from "@config/constants";
import Spinner from "@common/components/Spinner";
import { formatDate, replaceWith } from "@common/services/helpers";
var CancelSubscriptionFinalStep = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(CancelSubscriptionFinalStep, Component);
    var _super = _create_super(CancelSubscriptionFinalStep);
    function CancelSubscriptionFinalStep(props) {
        _class_call_check(this, CancelSubscriptionFinalStep);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            serverError: "",
            cancellationPending: false
        };
        _this.cancelSubscriptionRenewal = _this.cancelSubscriptionRenewal.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(CancelSubscriptionFinalStep, [
        {
            /**
     * Opens confirmation modal for subscription cancellation
     */ key: "openConfirmation",
            value: function openConfirmation(cancellationReason) {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, _$closeConfirmation = _this_props.closeConfirmation;
                this.props.openConfirmation({
                    message: i18n.account.areYouSureCancelSubscription,
                    declineMethod: _$closeConfirmation,
                    confirmMethod: function() {
                        return _this.cancelSubscriptionRenewal(cancellationReason);
                    }
                });
            }
        },
        {
            key: "cancelSubscriptionRenewal",
            value: /**
     * Method that handles the cancellation of the subscription renewal
     */ function cancelSubscriptionRenewal(cancellationReason) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props, _$cancelSubscriptionRenewal, _$getFullUserDetails, toggleComponent, _$closeConfirmation, enqueueSnackbar, i18n, response, error, errorText;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.state.cancellationPending) return [
                                    3,
                                    6
                                ];
                                _this_props = _this.props, _$cancelSubscriptionRenewal = _this_props.cancelSubscriptionRenewal, _$getFullUserDetails = _this_props.getFullUserDetails, toggleComponent = _this_props.toggleComponent, _$closeConfirmation = _this_props.closeConfirmation, enqueueSnackbar = _this_props.enqueueSnackbar, i18n = _this_props.i18n;
                                _$closeConfirmation();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                _this.setState({
                                    cancellationPending: true
                                });
                                return [
                                    4,
                                    _$cancelSubscriptionRenewal(cancellationReason)
                                ];
                            case 2:
                                response = _state.sent();
                                if (!(response.status === STATUS_CODE_SUCCESS)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _$getFullUserDetails()
                                ];
                            case 3:
                                _state.sent();
                                enqueueSnackbar(i18n.snackbar.cancelSubscriptionSuccess, {
                                    variant: SNACKBAR_VARIANT_SUCCESS,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                toggleComponent(SUBSCRIPTION);
                                _this.setState({
                                    cancellationPending: false
                                });
                                _state.label = 4;
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                enqueueSnackbar(i18n.snackbar.cancelSubscriptionFail, {
                                    variant: SNACKBAR_VARIANT_ERROR,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                _this.setState({
                                    cancellationPending: false
                                });
                                errorText = _this.props.i18n.errors["error".concat(error.subcode)];
                                _this.setState({
                                    serverError: errorText
                                });
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, componentName = _this_props.componentName, i18n = _this_props.i18n, toggleComponent = _this_props.toggleComponent, userDetails = _this_props.userDetails, componentMap = _this_props.componentMap, additionalProps = _this_props.additionalProps, _$openWriteToUs = _this_props.openWriteToUs;
                var serverError = this.state.serverError;
                componentMap[componentName].parentProps.activeRadioButtonValue = additionalProps.activeRadioButtonValue;
                var cancellationReason = additionalProps.activeRadioButtonValue;
                var parentProps = componentMap[componentName].parentProps;
                var cancelledAt = userDetails.subscription[0].currentTermEnd;
                var cancelRenewalDesc = /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: replaceWith(i18n.account.cancelRenewalDesc, formatDate(cancelledAt))
                    }
                });
                return /*#__PURE__*/ _jsxs("div", {
                    className: "main-wrapper",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "cancel-final-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: "heading",
                                    children: i18n.account.cancelSubscription
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "description",
                                    children: cancelRenewalDesc
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "description",
                                    children: i18n.account.backToBasicPlan
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "error-server ".concat(serverError ? "active" : ""),
                                    children: serverError
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    classes: {
                                        label: "ux-button-label"
                                    },
                                    className: "cancel-subscription-button button raised half-width pointer",
                                    onClick: function() {
                                        return _this.openConfirmation(cancellationReason);
                                    },
                                    children: this.state.cancellationPending ? /*#__PURE__*/ _jsx(Spinner, {}) : /*#__PURE__*/ _jsx(_Fragment, {
                                        children: i18n.account.cancelRenewal
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "modal-footer",
                            children: [
                                /*#__PURE__*/ _jsxs(Button, {
                                    classes: {
                                        label: "ux-button-label"
                                    },
                                    onClick: function() {
                                        return toggleComponent(componentMap[componentName].parentComponentName, parentProps);
                                    },
                                    className: "button-no-background go-back-button raised half-width float-left center-vertical",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "icon icon-keyboard-arrow-right"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: i18n.account.goBack
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Button, {
                                    classes: {
                                        label: "ux-button-label"
                                    },
                                    color: "primary",
                                    onClick: _$openWriteToUs,
                                    className: "button-no-background write-to-us-button write-to-us-link center-vertical raised half-width float-right pointer",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "icon icon-contact-us"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: i18n.writeToUs
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return CancelSubscriptionFinalStep;
}(Component);
export default withSnackbar(connect(null, {
    cancelSubscriptionRenewal: cancelSubscriptionRenewal,
    getFullUserDetails: getFullUserDetails,
    openWriteToUs: openWriteToUs,
    openConfirmation: openConfirmation,
    closeConfirmation: closeConfirmation
})(CancelSubscriptionFinalStep));
